import PrivilegieRoute from "./components/wrapped-routes/privilegie-route/PrivilegieRoute";
import InviteAcceptScreen from "./views/invite-accept-screen/InviteAcceptScreen";
import Login from "./views/login-view/Login";
import MiniAppInfoScreen from "./views/mini-app-info-screen/MiniAppInfoScreen";
import RegisterNewMiniApp from "./views/mini-app-register-screen/MiniAppRegisterScreen";
import MiniAppReviewList from "./views/mini-app-list-view/MiniAppListScreen";
import Logout from "./views/Logout";
import SalesReport from "./components/sales_report/SalesReport";
import CreateNewPassword from "./views/create-password-view/CreateNewPassword";
import CreateUserPassword from "./views/create-user-password/CreateUserPassword";
import ResetPassword from "./views/reset-password/ResetPassword";
import RedefinePassword from "./views/redefine_password/RedefinePassword";
import UserChangePassword from "./views/settings-view/user-change-password/UserChangePassword";
import SettingsView from "./views/settings-view/SettingsView";
import ManagerUserCredentials from "./views/settings-view/manager-user-credentials/ManagerUserCredentials";
import MassiveMiniappUpdate from "./views/massive-miniapp-update/MassiveMiniappUpdate";
import MiniAppPrivilegiesView from "./views/mini-app-privilegies-view/MiniAppPrivilegiesView";
import RoleView from "./views/role-view/RoleView";
import MiniAppRendererView from "./views/mini-app-renderer-view/MiniAppRendererView";
import Page404 from "./views/page-404/Page404.js";

import RoutesUtils from "./utils/routes-utils/RoutesUtils";
import ScopesEnum from "./utils/enums/ScopesEnum";
import ExpiredSignupWarn from "./views/expired-signup-warn/ExpiredSignupWarn";
import AuthView from "./views/auth-view/AuthView";
import ScopesView from "./views/scopes-view/ScopesView";
import CreateScope from "./views/create-scope-view/CreateScopeView";
import SelectOrganizationView from "./views/select-organization/SelectOrganizationView";
import Documentation from "./views/documentation-start/Documentation";
import GenerateCredentials from "./views/settings-view/generate-credentials/GenerateCredentials";

import UserList from "./views-v2/users/user-list/UserList";
import UserEdit from "./views-v2/users/user-edit/UserEdit";
import UserCreate from "./views-v2/users/user-create/UserCreate";
import ListRevision from "./views-v2/eitri-apps/revisions/list-revision/ListRevision";
import ListEitriApp from "./views-v2/eitri-apps/list-eitri-app/ListEitriApp";
import EitriAppEdit from "./views-v2/eitri-apps/eitri-app-edit/EitriAppEdit";

const routes = [
    {
        path: "/",
        exact: true,
        isPrivate: false,
        component: Login,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/user-management/users",
        exact: true,
        isPrivate: true,
        component: UserList,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/user-management/users/:email",
        exact: true,
        isPrivate: true,
        component: UserEdit,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/user-management/create-user",
        exact: true,
        isPrivate: true,
        component: UserCreate,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/eitri-app-management/eitri-apps",
        exact: true,
        isPrivate: true,
        component: ListEitriApp,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/eitri-app-management/eitri-apps/:eitriAppId",
        exact: true,
        isPrivate: true,
        component: EitriAppEdit,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/eitri-app-management/eitri-apps/:eitriAppId/revisions",
        exact: true,
        isPrivate: true,
        component: ListRevision,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/invites/:token/accept",
        exact: false,
        isPrivate: false,
        component: InviteAcceptScreen,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/applications/:slug/configurations",
        exact: true,
        isPrivate: true,
        component: MiniAppInfoScreen,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hasBreadCrumb: true
    },
    {
        path: "/applications/create",
        exact: true,
        isPrivate: true,
        component: RegisterNewMiniApp,
        isAdminRoute: false,
        requiredScopes: [ScopesEnum.WRITE_MINAPP],
        requiredActions: []
    },
    {
        path: "/applications/user/:email/reset_user_password",
        exact: true,
        isPrivate: true,
        component: CreateUserPassword,
        isAdminRoute: true,
        requiredScopes: ["manage_users"],
        requiredActions: [],
        hasBreadCrumb: true
    },
    {
        path: "/applications/:page",
        exact: true,
        isPrivate: true,
        component: MiniAppReviewList,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/developer/sales_report",
        exact: false,
        isPrivate: true,
        component: SalesReport,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/logout",
        exact: false,
        isPrivate: true,
        component: Logout,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/reset_password",
        exact: false,
        isPrivate: true,
        component: CreateNewPassword,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/redefine_password/:token",
        exact: true,
        isPrivate: false,
        component: RedefinePassword,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/accounts/password/reset/",
        exact: true,
        isPrivate: false,
        component: ResetPassword,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/settings",
        exact: true,
        isPrivate: true,
        component: SettingsView,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/settings/reset-password",
        exact: true,
        isPrivate: true,
        component: UserChangePassword,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/settings/manager-credential",
        exact: true,
        isPrivate: true,
        component: ManagerUserCredentials,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/settings/cli-generate-credential",
        exact: true,
        isPrivate: true,
        hideSidebar: true,
        component: GenerateCredentials,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/settings/generate-credential",
        exact: true,
        isPrivate: true,
        hideSidebar: true,
        component: GenerateCredentials,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/massive-miniapp-update",
        exact: true,
        isPrivate: true,
        component: MassiveMiniappUpdate,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/applications/user/:email/miniapp/:slug/privilegies",
        exact: true,
        isPrivate: PrivilegieRoute,
        component: MiniAppPrivilegiesView,
        isAdminRoute: true,
        requiredScopes: ["manage_miniapp_devs"],
        requiredActions: ["manage_miniapp_devs"],
        hasBreadCrumb: true
    },
    {
        path: "/miniapp-renderer",
        exact: true,
        isPrivate: true,
        component: MiniAppRendererView,
        isAdminRoute: true,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/not-found",
        exact: true,
        isPrivate: false,
        component: Page404,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/expired-signup-warn",
        exact: true,
        isPrivate: false,
        component: ExpiredSignupWarn,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/auth",
        exact: true,
        isPrivate: true,
        component: AuthView,
        isAdminRoute: true,
        requiredScopes: ["view_auth"],
        requiredActions: []
    },
    {
        path: "/auth/roles",
        exact: true,
        isPrivate: true,
        component: RoleView,
        isAdminRoute: true,
        requiredScopes: ["view_auth", "read_role"],
        requiredActions: [],
        hasBreadCrumb: true
    },
    {
        path: "/auth/scopes",
        exact: true,
        isPrivate: true,
        component: ScopesView,
        isAdminRoute: true,
        requiredScopes: ["view_auth", "read_scope"],
        requiredActions: [],
        hasBreadCrumb: true
    },
    {
        path: "/auth/scopes/create",
        exact: true,
        isPrivate: true,
        component: CreateScope,
        isAdminRoute: true,
        requiredScopes: ["view_auth", "write_scope"],
        requiredActions: [],
        hasBreadCrumb: true
    },
    {
        path: "/select-organization",
        exact: true,
        isPrivate: true,
        component: SelectOrganizationView,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: [],
        hideSidebar: true
    },
    {
        path: "/getting-started",
        exact: true,
        isPrivate: true,
        component: Documentation,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    },
    {
        path: "/docs/*",
        exact: true,
        isPrivate: true,
        component: Documentation,
        isAdminRoute: false,
        requiredScopes: [],
        requiredActions: []
    }
];

export default RoutesUtils.getItemsWithOrder(routes);
